<template>
    <div class="mine-arrow-cell" @click="onCellClick">
        <div class="mine-list-item" slot="cellLeft">
            <img :style="{ width: `${model.iconWidth}px`, height: `${model.iconHeight}px` }" :src="model.icon">
            <p class="mine-list-item-title">{{ model.title }}</p>
        </div>
        <img class="mine-arrow-cell-arrow" :src="rightLightArrowIcon">
    </div>
</template>

<script>
export default {
    props: {
        model: {
            type: Object,
            required: true
        }
    },
    data() { 
        return {
            rightLightArrowIcon: require("@img/mine-right-light-arrow.png")
        };
    },
    methods: {
        onCellClick() {
            this.$emit("onCellClick", this.model.title);
        }
    }
};
</script>

<style lang="scss" scoped>

.mine-arrow-cell {
    width: 100%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-arrow {
        width: 9px;
        height: 15px;
    }
}
.mine-list-item {
    display: flex;
    align-items: center;

    &-title {
        color: black;
        font-size: 14px;
        margin-left: 22px;
    }
}
</style>